// extracted by mini-css-extract-plugin
module.exports = {"message":"style__message__77II7","complete":"style__complete__w2NXH"};